<template>
  <div
    class="card-lists"
    v-r-loading.fullscreen="debtRepayLoading"
  >
    <div class="card-list_content">
      <div
        @click="openProgressVisble"
        v-if="isH5 && orderData.status<600"
        class="order-status__desc finger-style animation-order-status"
      >
        <div class="ellipsis order-status__desc-text">
          {{ orderData.statusDesc }}
        </div>
        <i class="icon-outline_entrance"></i>
      </div>

      <!-- 订单进度  -->
      <div
        @click="openProgressVisble"
        v-if="isShowOrderStatus"
        class="order-status__desc finger-style"
        :class="{ 'order-status__desc-sticky': statusSticky }"
      >
        <div class="ellipsis order-status__desc-text">
          {{ orderData.statusDesc }}
        </div>
        <i class="icon-outline_entrance"></i>
      </div>
      <div class="card-lists__content">
        <div
          class="mg_10"
          v-if="getOrderPickInfo"
        >
          <OrderPick :orderPickInfo="getOrderPickInfo" />
        </div>
        <div
          class="mg_10"
          v-if="getOrderBranchInfo"
        >
          <OrderStatusCard
            :orderBranchInfo="getOrderBranchInfo"
            :orderId="orderData.orderId"
            :status="orderData.status"
            @confrimCard="confrimCard"
            @goIconUrl="goIconUrl"
          />
        </div>
        <div
          class="mg_10"
          v-if="getOrderAbnormalInfo"
        >
          <OrderAbnormalInfo
            :orderabnormalInfo="getOrderAbnormalInfo"
            @goIconUrl="goIconUrl"
            @confrimPay="confrimPay"
          />
        </div>
        <div
          class="mg_10"
          v-if="orderId"
        >
          <OrderPartyCard
            :info="getPartyInfo"
            :orderId="orderId"
            :orderStatus="orderData.status"
            :deliveryType="+orderData.deliveryType"
          />
        </div>
        <!-- 帮助中心卡片 -->
        <div
          class="mg_10"
          v-if="getOrderFAQ"
        >
          <HelpCard
            :wordChain="getwordChain"
            :orderId="orderId"
            @goIconUrl="goIconUrl"
          />
        </div>
        <!-- 商品信息卡片 -->
        <div
          class="mg_10"
          v-if="getGoodsInfo"
        >
          <OrderGoodsInfoCard :info="getGoodsInfo" />
        </div>
        <div
          class="mg_10"
          v-if="getOrderDetail"
        >
          <OrderDetailCard :orderDetail="getOrderDetail" />
        </div>
      </div>

      <!-- 进度弹出层 -->
      <OrderProgress
        :orderFlows="orderData.orderFlows"
        :orderId="orderData.orderId"
        :status="orderData.status"
        v-model="progressVisble"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { throttle } from 'lodash-es';
import HelpCard from '@/components/HelpCard';
import OrderProgress from '@/components/OrderProgress';
import OrderPick from '@/components/OrderPick';
import OrderStatusCard from '@/components/OrderStatusCard';
import OrderAbnormalInfo from '@/components/OrderAbnormalInfo';
import OrderDetailCard from '@/components/OrderDetailCard';
import OrderPartyCard from '@/components/OrderPartyCard';
import OrderGoodsInfoCard from '@/components/OrderGoodsInfoCard';
let _self = null;
export default {
  name: 'CardLists',
  components: {
    HelpCard,
    OrderProgress,
    OrderPick,
    OrderStatusCard,
    OrderAbnormalInfo,
    OrderPartyCard,
    OrderGoodsInfoCard,
    OrderDetailCard,
    /** @desc 评价 */
    // Evaluate,
    // Star,
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      debtRepayLoading: ({ order }) => order.debtRepayLoading,
    }),
    getOrderFAQ() {
      return this.layoutCards?.OrderFAQ?.data?.orderFAQ;
    },
    getwordChain() {
      return this.layoutCards?.OrderFAQ?.data?.orderFAQ?.wordChain;
    },
    getOrderPickInfo() {
      return this.layoutCards?.OrderPickInfo?.data?.orderPickInfo;
    },
    getOrderBranchInfo() {
      return this.layoutCards?.OrderBranchInfo?.data?.orderBranchInfo;
    },
    getOrderAbnormalInfo() {
      return this.layoutCards?.OrderAbnormalInfo?.data?.orderAbnormalInfo;
    },
    getGoodsInfo() {
      return this.layoutCards?.OrderItem?.data?.orderItem;
    },
    getOrderDetail() {
      return this.layoutCards?.OrderBaseInfo?.data?.orderBaseInfo?.showList;
    },
    getPartyInfo() {
      return this.layoutCards?.OrderServer?.data?.orderServer;
    },
    getOrderComment() {
      return this.layoutCards?.OrderComment?.data?.orderComment;
    },
    commentEdit() {
      return !this.getOrderComment?.score;
    },
    isShowOrderStatus() {
      return !(this.isH5 && this?.orderData?.status < 600);
    },
  },
  props: {
    layoutCards: Object,
    orderId: String,
    orderData: Object,
    progressShow: Boolean,
    statusSticky: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    progressShow(newV) {
      if (newV) {
        this.progressVisble = newV;
      }
    },
    progressVisble(newV) {
      if (!newV) {
        this.$emit('update:progressShow', newV);
      }
    },
  },
  data() {
    return {
      progressVisble: false,
    };
  },
  mounted() {
    this.isH5OrderComplete();
    this.$nextTick(()=>{
        // 初次进入的时候，默认高度给0
       if (!this.isShowOrderStatus) {
          document?.querySelector('.animation-order-status')?.classList?.add('animation-height');
       }
    })
  },
  beforeDestroy() {
     if (this.isH5) {
      _self = null;
      window.removeEventListener('scroll', this.handleScroll, true);
     }
  },
  methods: {
    ...mapActions('order', ['getEvaTagList', 'getEvaInfo']),
    isH5OrderComplete() {
      // h5完成订单时候的吸顶逻辑
      if (this.isH5) {
        window.addEventListener('scroll', this.handleScroll, true);
        _self = this;
      }
    },
    handleScroll: throttle(e => {
      if (_self?.orderData?.status < 600) {
        const { height } = document?.querySelector('#map')?.getBoundingClientRect();
        const animationElHeight = document?.querySelector('.animation-order-status')?.getBoundingClientRect()?.height;
        const { top=0 } = document?.querySelector('.card-list_content')?.getBoundingClientRect();
        let startOpt = (top - animationElHeight) > height ? height : (top - animationElHeight);
        let opacity = 1 - (startOpt / height).toFixed(2) * 1;
        opacity = opacity > 1 ? 1 : opacity
        opacity = opacity < 0.1 ? 0 : opacity
        if(opacity ==0) {
            document.querySelector('.animation-order-status').classList.add('animation-height');
        }else {
            document.querySelector('.animation-order-status').classList.remove('animation-height');
        }
        document.querySelector('.animation-order-status').style.opacity = opacity;
      } else {
        const cardListContent = document?.querySelector('.card-list_content');
        const orderStatusDesc = document?.querySelector('.order-status__desc');
        const { top } = cardListContent?.getBoundingClientRect();
        if (top <= 0) {
          cardListContent.classList.add('position-top-padding');
          orderStatusDesc.classList.add('position-top');
        } else {
          cardListContent.classList.remove('position-top-padding');
          orderStatusDesc.classList.remove('position-top');
        }
      }
    }, 10),
    openProgressVisble() {
      this.progressVisble = true
    },
    confrimCard() {
      this.$emit('confrimCard');
    },
    confrimPay(val) {
      this.$emit('confrimPay', val);
    },
    goIconUrl(val) {
      this.$emit('goIconUrl', val);
    },
  },
};
</script>
<style lang="scss" scoped>
.mg_10 {
  margin-bottom: 16px;
}
.order-status__desc-sticky {
  position: sticky;
  top: 0;
}
.order-status__desc {
  background: #f5f5f7;
  height: 64px;
  line-height: 64px;
  padding-right: 20px;
  font-family: 'Aspira Medium';
  font-size: 20px;
  color: #000000;
  font-weight: 500;
  display: flex;
  align-items: center;
  z-index: 9;
  i {
    font-size: 14px;
  }
}
.card-lists {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.card-list_content {
  margin: 0 12px;
}
.card-lists__content {
  flex: 1;
  overflow: hidden;
  overflow-y: auto;
}
.star-card {
  background: #ffffff;
  border-radius: 6px;
  font-family: 'Aspira Medium';
  font-size: 16px;
  color: #000000;
  font-weight: 500;
  align-items: center;
  padding: 20px 10px;
  .star-title {
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 768px) {
  .animation-height {
    height: 0 !important;
    width: 0 !important;
  }
  .position-top {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    padding: 0 rem(28);
  }
  .animation-order-status {
    @extend .position-top;
    opacity: 0;
  }
  .position-top-padding {
    padding-top: rem(128);
  }
  .mg_10 {
    margin-bottom: rem(32);
  }

  .order-status__desc {
    height: rem(128);
    line-height: rem(128);
    padding-right: rem(40);
    font-size: rem(40);

    i {
      font-size: rem(28);
    }
  }

  .card-list_content {
    margin: 0 rem(28);
    // height: 100vh;
  }

  .star-card {
    border-radius: rem(12);
    font-size: rem(32);
    padding: rem(40) rem(20);
    .star-title {
      margin-bottom: rem(40);
    }
  }
}
</style>
